
import React, { Component } from 'react';
import { connect } from "react-redux";

import { AD_MORE_TIME_CLICKED, AD_FINAL_RESULTS } from '../../utils/constants';
import { trackingWrapper } from '../../utils/analytics';
import IronSource from './IronSource';
import VideoOverlay from './VideoOverlay';

const NAMESPACE = '[ RewardAdContainer ]';
export const RANDOM_END_RESULT_VIDEOS = 1;

class RewardAdContainer extends Component {

	componentWillMount(){

		// tracking
		let trackingTag = 'ASgame-2nd-replay-gate-ad';
		if (this.props.showVideoAd === AD_MORE_TIME_CLICKED){
			trackingTag = 'ASgame-more-time-ad';
		}	

		if (this.props.showVideoAd === AD_FINAL_RESULTS) {
			trackingTag = 'ASgame-final-results-ad';
		}

		trackingWrapper('event', trackingTag, {'event_category':'america-says-game'});
	}

	render(){

		if (this.props.rewardVideo.ready && this.props.rewardVideo.support === true) {
			return <IronSource 
				showVideoAd={this.props.showVideoAd}
				handleVideoOverlayClose={this.props.handleVideoOverlayClose} 
				videoAdType={this.props.trackingType}
			/>
		}

		return <VideoOverlay 
			showVideoAd={this.props.showVideoAd}
			handleVideoOverlayClose={this.props.handleVideoOverlayClose}
			videoAdType={this.props.trackingType}
		/>;
	}
}

const mapStateToProps = state => ({
  rewardVideo: state.rewardVideo
});

export default connect(
  mapStateToProps,
)(RewardAdContainer);


// WEBPACK FOOTER //
// ./src/js/components/ads/RewardAdContainer.js